import React from 'react'
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react'

export default function DataTablePagination({ table }) {
  const pagination = table.getState().pagination
  const totalRows = table.getRowCount()
  const from = pagination.pageIndex * pagination.pageSize + 1
  const to = (pagination.pageIndex + 1) * pagination.pageSize
  const finalTo = Math.min(to, totalRows)

  return (
    <div className="tw-flex tw-items-center tw-justify-center tw-py-3 tw-px-1 tw-gap-2">
      <button
        onClick={() => table.firstPage()}
        disabled={!table.getCanPreviousPage()}
        className="tw-hidden sm:tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-slate-200 tw-bg-white tw-text-slate-500 tw-transition-colors hover:tw-bg-slate-50 hover:tw-text-slate-700 disabled:tw-opacity-40 disabled:tw-pointer-events-none"
        title="First page"
      >
        <ChevronsLeft className="tw-h-4 tw-w-4" />
      </button>
      <button
        onClick={() => table.previousPage()}
        disabled={!table.getCanPreviousPage()}
        className="tw-inline-flex tw-h-8 tw-items-center tw-justify-center tw-gap-1 tw-rounded-md tw-border tw-border-slate-200 tw-bg-white tw-px-2.5 tw-text-sm tw-text-slate-500 tw-transition-colors hover:tw-bg-slate-50 hover:tw-text-slate-700 disabled:tw-opacity-40 disabled:tw-pointer-events-none"
      >
        <ChevronLeft className="tw-h-4 tw-w-4" />
        <span className="tw-hidden sm:tw-inline">Prev</span>
      </button>
      <div className="tw-flex tw-items-center tw-text-sm tw-font-medium tw-text-slate-600 tw-px-2 tw-whitespace-nowrap">
        {from}-{finalTo} of {totalRows.toLocaleString()}
      </div>
      <button
        onClick={() => table.nextPage()}
        disabled={!table.getCanNextPage()}
        className="tw-inline-flex tw-h-8 tw-items-center tw-justify-center tw-gap-1 tw-rounded-md tw-border tw-border-slate-200 tw-bg-white tw-px-2.5 tw-text-sm tw-text-slate-500 tw-transition-colors hover:tw-bg-slate-50 hover:tw-text-slate-700 disabled:tw-opacity-40 disabled:tw-pointer-events-none"
      >
        <span className="tw-hidden sm:tw-inline">Next</span>
        <ChevronRight className="tw-h-4 tw-w-4" />
      </button>
      <button
        onClick={() => table.lastPage()}
        disabled={!table.getCanNextPage()}
        className="tw-hidden sm:tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-slate-200 tw-bg-white tw-text-slate-500 tw-transition-colors hover:tw-bg-slate-50 hover:tw-text-slate-700 disabled:tw-opacity-40 disabled:tw-pointer-events-none"
        title="Last page"
      >
        <ChevronsRight className="tw-h-4 tw-w-4" />
      </button>
    </div>
  )
}
